import { ref, readonly } from 'vue';

// Create a single instance of the error state that will be shared across the app
const show = ref(false);
const errorMessage = ref('');

/**
 * Composable for managing error popup state throughout the application
 * Provides a centralized way to show error messages to the user
 */
export const useErrorPopup = () => {
  /**
   * Show an error message in the popup
   * @param message - The error message to display
   */
  const showError = (message: string) => {
    errorMessage.value = message;
    show.value = true;
  };

  /**
   * Hide the error popup
   */
  const hideError = () => {
    show.value = false;
  };

  /**
   * Clears the error message
   */
  const clearErrorMessage = () => {
    errorMessage.value = '';
  };
  /**
   * Show a success message in the popup
   * @param message - The success message to display
   */
  const showSuccess = (message: string) => {
    errorMessage.value = message; // Reuse the same state for success messages
    show.value = true;
  };  // Create a useError object with reactive properties and methods
  const useError = {
    show,
    errorMessage,
    showError,
    hideError,
    clearErrorMessage,
    showSuccess
  };

  return {
    useError
  };
};
